/**
 * Drivers Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/drivers
 */

const DRIVERS = [
  {
    key: 'enhance',
    name: 'Enhance Hosting',
    description: 'Hosting-Provisioning über das Enhance-Control-Panel.',
    configSchema: [
      { key: 'apiUrl', label: 'API URL', type: 'url' },
      { key: 'apiToken', label: 'API Token', type: 'secret' },
      { key: 'defaultPackage', label: 'Default-Package-ID', type: 'string' },
    ],
  },
  {
    key: 'cloudflare',
    name: 'Cloudflare DNS',
    description: 'DNS-Records für Customer-Domains.',
    configSchema: [
      { key: 'apiToken', label: 'API Token', type: 'secret' },
      { key: 'accountId', label: 'Account-ID', type: 'string' },
    ],
  },
  {
    key: 'registrar',
    name: 'Domain Registrar',
    description: 'Domain-Registrierung via Registrar-API.',
    configSchema: [
      { key: 'apiUrl', label: 'API URL', type: 'url' },
      { key: 'apiToken', label: 'API Token', type: 'secret' },
    ],
  },
  {
    key: 'wireguard',
    name: 'WireGuard VPN',
    description: 'Pro-Customer VPN-Peer-Provisioning.',
    configSchema: [
      { key: 'serverUrl', label: 'WG-Server URL', type: 'url' },
      { key: 'adminKey', label: 'Admin-Schlüssel', type: 'secret' },
    ],
  },
];

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_DRIVERS_DB__) {
    window.__ORBIT_DRIVERS_DB__ = {
      enhance: { globalEnabled: true, tenantEnabled: true, config: { apiUrl: 'https://panel.example.com', defaultPackage: 'pkg-pro' }, lastSuccessAt: Date.now() - 60_000, lastFailureAt: null, lastError: null },
      cloudflare: { globalEnabled: true, tenantEnabled: true, config: { accountId: 'cf-acc-12345' }, lastSuccessAt: Date.now() - 4 * 60_000, lastFailureAt: null, lastError: null },
      registrar: { globalEnabled: true, tenantEnabled: false, config: {}, lastSuccessAt: null, lastFailureAt: null, lastError: null },
      wireguard: { globalEnabled: false, tenantEnabled: false, config: {}, lastSuccessAt: null, lastFailureAt: Date.now() - 6 * 3_600_000, lastError: 'connection refused (peer unreachable)' },
    };
  }
  return window.__ORBIT_DRIVERS_DB__;
}

export function driversFixture() {
  const db = persist();
  return {
    drivers: DRIVERS.map((d) => {
      const state = db[d.key] ?? { globalEnabled: false, tenantEnabled: false, config: {}, lastSuccessAt: null, lastFailureAt: null, lastError: null };
      return {
        ...d,
        globalEnabled: state.globalEnabled,
        tenantEnabled: state.tenantEnabled,
        config: state.config,
        lastSuccessAt: state.lastSuccessAt ? new Date(state.lastSuccessAt).toISOString() : null,
        lastFailureAt: state.lastFailureAt ? new Date(state.lastFailureAt).toISOString() : null,
        lastError: state.lastError,
      };
    }),
  };
}

export function updateDriverFixture(key, patch) {
  const db = persist();
  if (!db[key]) db[key] = { globalEnabled: false, tenantEnabled: false, config: {}, lastSuccessAt: null, lastFailureAt: null, lastError: null };
  if ('globalEnabled' in patch) db[key].globalEnabled = patch.globalEnabled;
  if ('tenantEnabled' in patch) db[key].tenantEnabled = patch.tenantEnabled;
  if (patch.config) db[key].config = { ...db[key].config, ...patch.config };
  return { ok: true };
}

export function removeDriverTenantFixture(key) {
  const db = persist();
  if (db[key]) {
    db[key].tenantEnabled = false;
    db[key].config = {};
  }
  return { ok: true };
}
